import type { Review } from '@/mocks/reviews';

interface ReviewCardProps {
  review: Review;
}

export default function ReviewCard({ review }: ReviewCardProps) {
  return (
    <div className="bg-background-50 rounded-2xl p-5 md:p-6 break-inside-avoid mb-5">
      <div className="flex items-center gap-3 mb-4">
        <div className="w-11 h-11 rounded-full overflow-hidden shrink-0">
          <img
            src={review.avatar}
            alt={review.name}
            className="w-full h-full object-cover"
          />
        </div>
        <div>
          <p className="text-sm font-semibold text-foreground-900">{review.name}</p>
          <p className="text-xs text-foreground-400">{review.username}</p>
        </div>
      </div>
      <div className="flex items-center gap-0.5 mb-3">
        {Array.from({ length: 5 }).map((_, i) => (
          <i
            key={i}
            className={`text-xs ${i < review.rating ? 'ri-star-fill text-secondary-500' : 'ri-star-fill text-foreground-200'}`}
          ></i>
        ))}
      </div>
      <p className="text-sm text-foreground-600 leading-relaxed">
        &ldquo;{review.content}&rdquo;
      </p>
    </div>
  );
}